import styled from 'styled-components';

export default styled.h2`
    font-size: ${({theme}) => theme.fontSize.m};
`;
